import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { BaseSafeFormView, BaseView } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import {
  WalletInstructionsSteps,
  OpenWalletButton,
} from '@/features/kem-card/components'
import { KemCard } from '@/components/KemCard'
import { useUserStore } from '@/store/useUserStore'
import { useKemCardStore } from '@/store/useKemCardStore'
import { kemCardStylesList } from '@/constants/kemCardStylesList'

export const KemCardWalletInstructionsScreen: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const location = useLocation()
  const platform = location.state?.platform as 'apple' | 'google'

  // Get card info from wallet state (secure, non-sensitive data)
  const wallet = useUserStore((state) => state.wallet)
  const cardFromWallet = wallet?.cards?.[0]

  const kemCardId = cardFromWallet?.id

  // Get card style from store
  const kemCardStyleKey = useKemCardStore((state) => state.kemCardStyleKey)

  const selectedKemCardStyle = kemCardStylesList.find(
    (item) => item.key === kemCardStyleKey,
  )

  return (
    <BaseSafeFormView flex={1} bgColor="background.screen" className="h-full">
      <StickyHeaderNavigation
        title={t(
          platform === 'google'
            ? 'screens:kemCard.walletInstructions.addingToGoogleWallet'
            : 'screens:kemCard.walletInstructions.addingToAppleWallet',
        )}
        onBackPress={() => navigate(-1)}
      />

      <BaseView py={12} gap={30} flex={1}>
        {/* Card Preview */}
        <BaseView style={{ marginTop: 60, marginBottom: 30 }}>
          {cardFromWallet && selectedKemCardStyle ? (
            <KemCard
              kemCardStyleItem={selectedKemCardStyle}
              cardInfo={cardFromWallet}
              kemCardId={kemCardId}
              kemCardEnabled={cardFromWallet?.state === 'active'}
              containerStyle={{ alignSelf: 'center' }}
            />
          ) : (
            <BaseView
              style={{
                alignSelf: 'center',
                padding: '20px',
                textAlign: 'center',
              }}
            >
              {/* Fallback if no card found */}
            </BaseView>
          )}
        </BaseView>

        {/* Instructions */}
        <WalletInstructionsSteps platform={platform} />

        {/* Open Wallet Button */}
        <BaseView>
          <OpenWalletButton platform={platform} />
        </BaseView>
      </BaseView>
    </BaseSafeFormView>
  )
}
